export const GroupEmails = [
    "Laboratory Supervisors",
    //add more if necessary
];